import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Card, Row, Col, Label } from "reactstrap";
import { useSelector } from "react-redux";
import Layout from "../../components/Wrappers/Layout";
import val from "../../getThemeDetails";
import constants from "../../config/constants";



function InvoiceManagement() {
  const { t } = useTranslation();

  const {
    data: { isMyBankAllowed, isMyWalletAllowed, isMyCardAllowed },
  } = useSelector(({ walletSetting }) => walletSetting);

  const getMappedListRes = useSelector(
    ({ getMappedList }) => getMappedList
  );
	const Theme = useSelector((state) => state.theme.theme);

  const history = useHistory();
  const { pathname } = useLocation();

  const options = [
    {
      id: 1,
      label: "Merchant Invoice",
      // route: "/index/risk-rules",merchantInvoice
      route: "/index/merchantInvoice",
      // route: "/index/merchant-invoice",
      src: `${process.env.PUBLIC_URL}/${Theme}/merchant invoice.png`,
      flag: "MERCHANT INVOICE",
    },
    {
      id: 2,
      // label: "My Banks",
      label: "Merchant Configuration",
      // route: "/index/block-country",
      route: "/index/merchantConfiguration",
      src: `${process.env.PUBLIC_URL}/${Theme}/merchant configuration1.png`,
      flag: "MERCHANT CONFIGURATION",
    },
  
    // {
    //   id: 4,
    //   label: "My Wallets",
    //   route: "/index/my-wallets",
    //   src: `${process.env.PUBLIC_URL}/${val.theme}/MyWallets.png`,
    // },
    //   {
    //     id: 5,
    //     label: "Create Wallet",
    //     route: "/index/create-wallet",
    //     src: `${process.env.PUBLIC_URL}/${val.theme}/ApiKey.png`,
    //   },
  ];

  const filteredOptns = options.filter(({ label }) => {
    // if (
    //   label === "My Cards" && !constants.visibleFlags.includes(isMyCardAllowed)
    // ) {
    //   return label !== "My Cards";
    // }
    // else if (
    //   label === "My Banks" &&  !constants.visibleFlags.includes(isMyBankAllowed)
    // )
    // {
    //   return label !== "My Banks";
    // }
    if (
      label === "My Wallets" &&
      !constants.visibleFlags.includes(isMyWalletAllowed)
    ) {
      // return label !== "My Wallets";
    } else return true;
  });
  // .sort((a, b) => {
  //   return a.label > b.label ? 1 : -1;
  // });

  if (!filteredOptns.length) {
    return (
      <Layout>
        <Card className="mk-root">
          <Row className="mk-row m-auto">No My Accounts Available</Row>
        </Card>
      </Layout>
    );
  }

  const handleRoute = (route) => {
    history.push({ pathname: route, state: { from: pathname } });
  };

  return (
    <Layout>
      <Card className="mk-root">
        <Row className="mk-row">
          {options.map(({ id, src, label, route, flag }) => {
            if (
              getMappedListRes.success &&
              getMappedListRes.data.moduleAllocationVO.masterSubModuleMappingList.includes(flag)
            ) {
              return (<Col key={id} md={4} sm={4} xs={6}>
                <div className="mk-imageRoot" onClick={() => handleRoute(route)}>
                  <div className="mk-imageContainer">
                    <img className="mk-image" src={src} alt={label} />
                  </div>
                  <Label for={label} className="fs-14">
                    {t(label)}
                  </Label>
                </div>
              </Col>)
            }
          })}
        </Row>
      </Card>
    </Layout>
  );
}

export default InvoiceManagement;
